import {
 GetOrdersRequest, GetOrdersResponse, OrdersCancelOrderPaymentRequest, OrdersCancelOrderPaymentResponse
} from "./requestsResponses";
import { OrdersApiMethods } from "./methods";
import { execute } from "../../apiCommandsExecutor";
import { ExecutionStatus } from "../general/requestsResponses";
import { GetOrderRequest, GetOrderResponse } from "./requestsResponses";


export const getOrders = async (params: GetOrdersRequest) => {
    const response = await execute<GetOrdersRequest, GetOrdersResponse>(
        OrdersApiMethods.getOrders,
        params);
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        orders: response.data.orders
    }
};




export const getOrder = async (params: GetOrderRequest) => {
    const response = await execute<GetOrderRequest, GetOrderResponse>(
        OrdersApiMethods.getOrder,
        params);
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        order: response.data.order
    }
};

export const returnPayment = async (params: OrdersCancelOrderPaymentRequest) => {
    const response = await execute<OrdersCancelOrderPaymentRequest, OrdersCancelOrderPaymentResponse>(
        OrdersApiMethods.ordersCancelOrderPayment,
        params);
    return response.data
};

